const MOBILE_BREAKPOINT_PX = 768;

export function isMobileScreen(): boolean {
  return window.innerWidth < MOBILE_BREAKPOINT_PX;
}
